export default __webpack_public_path__ + "static/mobilepp-a08ba3f12365969da3b520ee8fc40f90.gif";